import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { isVirtualKeyboardVisible } from "./ui.es.js";
import "../_ui-71f9b37c.mjs";
import "../_i18n-e414d464.mjs";
import "../index-64135f7d.mjs";
import "../index-703c58ee.mjs";
import "../index-38c53cf2.mjs";
import "../i18n-35335a5c.mjs";
import "../malarkeyTwilioAdapter-1c296255.mjs";
import "../index-13be80af.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../_debug-8b5c3032.mjs";
import "joi";
import "../helpers-674591c1.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import "../index-fd2245c5.mjs";
const viewportHeight = ref(0);
const viewportWidth = ref(0);
const viewportOffsetTop = ref(0);
const viewportOffsetLeft = ref(0);
const virtualKeyboardVisible = ref(false);
const viewport = computed(() => ({
  height: viewportHeight.value,
  width: viewportWidth.value,
  offsetTop: viewportOffsetTop.value,
  offsetLeft: viewportOffsetLeft.value,
  virtualKeyboard: virtualKeyboardVisible.value
}));
const nativeEventHandler = () => {
  if ("undefined" === typeof window || !("visualViewport" in window) || null === window.visualViewport) {
    viewportHeight.value = 0;
    viewportWidth.value = 0;
    viewportOffsetTop.value = 0;
    viewportOffsetLeft.value = 0;
  } else {
    viewportHeight.value = window.visualViewport.height;
    viewportWidth.value = window.visualViewport.width;
    viewportOffsetTop.value = window.visualViewport.offsetTop;
    viewportOffsetLeft.value = window.visualViewport.offsetLeft;
  }
  virtualKeyboardVisible.value = isVirtualKeyboardVisible();
};
const initViewport = () => {
  if ("undefined" === typeof window) {
    return;
  }
  window.addEventListener("resize", nativeEventHandler);
  window.addEventListener("scroll", nativeEventHandler);
  window.addEventListener("focus", nativeEventHandler);
  window.addEventListener("blur", nativeEventHandler);
  window.addEventListener("touchstart", nativeEventHandler);
  window.addEventListener("touchend", nativeEventHandler);
  window.addEventListener("orientationchange", nativeEventHandler);
  if ("visualViewport" in window && null !== window.visualViewport) {
    window.visualViewport.addEventListener("resize", nativeEventHandler);
    window.visualViewport.addEventListener("scroll", nativeEventHandler);
  }
  window.addEventListener("touchstart", nativeEventHandler);
  window.addEventListener("touchend", nativeEventHandler);
  window.addEventListener("touchcancel", nativeEventHandler);
  nativeEventHandler();
};
const destroyViewport = () => {
  if ("undefined" === typeof window) {
    return;
  }
  window.removeEventListener("resize", nativeEventHandler);
  window.removeEventListener("scroll", nativeEventHandler);
  window.removeEventListener("focus", nativeEventHandler);
  window.removeEventListener("blur", nativeEventHandler);
  window.removeEventListener("touchstart", nativeEventHandler);
  window.removeEventListener("touchend", nativeEventHandler);
  window.removeEventListener("orientationchange", nativeEventHandler);
  if ("visualViewport" in window && null !== window.visualViewport) {
    window.visualViewport.removeEventListener("resize", nativeEventHandler);
    window.visualViewport.removeEventListener("scroll", nativeEventHandler);
  }
  window.removeEventListener("touchstart", nativeEventHandler);
  window.removeEventListener("touchend", nativeEventHandler);
  window.removeEventListener("touchcancel", nativeEventHandler);
};
const useViewport = () => {
  onMounted(() => {
    initViewport();
  });
  onBeforeUnmount(() => {
    destroyViewport();
  });
  return { viewport };
};
export {
  destroyViewport,
  initViewport,
  useViewport,
  viewport
};
//# sourceMappingURL=vue-ui.es.js.map
